import "./form-campaign.scss";

import { Constraint } from "@core/model/constraint.enum";
import { CampaignFormSchema } from "@factory/form/form.rule";
import { useQyGetLevel } from "@factory/query/level.query";
import { LabelValue } from "@shared/models/label-value.interface";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { Divider } from "primereact/divider";
import { useFormContext } from "react-hook-form";

import { appFeature } from "../../../app.feature";

type InputFormSchema = CampaignFormSchema;
export function FormCampaign() {
  const { pointsText, stampsText } = appFeature.config.label;
  const { control, watch } = useFormContext<CampaignFormSchema>();
  const { data: response } = useQyGetLevel("", 9999);
  const levelOption = LabelValue.MapArray(
    response?.data || [],
    (item) => item.name,
    (item) => item.code
  );

  const constraintOption = [
    {
      label: `${Constraint.AND} (${pointsText} & ${stampsText} both deducted)`,
      value: Constraint.AND,
    } as LabelValue,
    {
      label: `${Constraint.OR} (${pointsText} OR ${stampsText} will be deducted)`,
      value: Constraint.OR,
    } as LabelValue,
  ];
  const isContinuousRedeem = watch("multiRedeem");

  return (
    <div id="FormCampaign" className="campaign">
      <ImageControl<InputFormSchema>
        control={control}
        name="file"
        label="Campaign File"
        imagePreviewClass="w-32 h-32"
      />

      <Divider />
      <DropdownControl<InputFormSchema>
        control={control}
        name="level"
        label="Level"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        options={levelOption}
        placeholder="Enter level"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label={pointsText}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter ${pointsText}`}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label={stampsText}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter ${stampsText}`}
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="redeemByPoints"
        label={`Redeem By ${pointsText}`}
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="redeemByStamp"
        label={`Redeem By ${stampsText}`}
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="multiRedeem"
        label="Continous Redemption"
        containerClassName="pb-2"
      />
      {isContinuousRedeem ? null : (
        <InputDigitControl<InputFormSchema>
          control={control}
          name="redeemLimit"
          label="Redeem Limit"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter redeemLimit"
        />
      )}
      <InputDigitControl<InputFormSchema>
        control={control}
        name="limitPerMonth"
        label="Limit Per Month (Optional)"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter Limit Per Month"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="startDate"
        label="Start Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="endDate"
        label="End Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="constraint"
        label="Criteria"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        options={constraintOption}
        placeholder="Enter criteria"
      />
    </div>
  );
}

export default FormCampaign;
